import React from 'react';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './SideDrawer.css';
import Plot from 'react-plotly.js';
import { Box } from '@mui/material';

const PieChart = (props) => {
  return (
    <>
      <Box className="pie-component-div">
        <Plot
          data={props.data}
          config={{ responsive: ' true' }}
          layout={{
            width: 400,
            height: 400,
            margin: { t: 0 },
            legend: {
              orientation: 'h',
              x: 0.5,
              y: -0.2,
              xanchor: 'center',
              yanchor: 'bottom',
              font: { family: 'Montserrat, sans- serif' },
            },
          }}
        />
      </Box>
    </>
  );
};

export default PieChart;
